export const getCosts = (costs, locations) => {
  return Object.fromEntries(
    Object.entries(costs)
      .filter(([crn, cost]) => locations[crn] && cost !== '')
      .map(([crn, cost]) => [crn, Number(cost)])
  );
};

export const isProductTypeConcrete = productType => productType === 'CONCRETE';
